import {
  Box,
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import {TablerX} from '../../icons';
import usePlannerStyles from '../planner/usePlannerStyles';

const SIGN_OUT_CARD_PADDING = {base: 4, md: 5};
const SIGN_OUT_CLOSE_BUTTON_SIZE = '1.5rem';
const SIGN_OUT_CLOSE_BUTTON_TOP = {
  base: 'calc(1rem + 0.4375rem)',
  md: 'calc(1.25rem + 0.4375rem)',
};
const SIGN_OUT_CLOSE_BUTTON_X_ALIGN_OFFSET = '0.25rem';

const SignOutConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
}: Record<string, any>) => {
  const styles = usePlannerStyles();

  const handleConfirm = () => {
    onClose?.();
    onConfirm?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="xl"
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        bg="transparent"
        boxShadow="none"
        w="calc(100% - 2rem)"
        maxW="500px"
        mx={4}
      >
        <IconButton
          aria-label="Close"
          icon={<TablerX size={16} />}
          position="absolute"
          top={SIGN_OUT_CLOSE_BUTTON_TOP}
          right={SIGN_OUT_CARD_PADDING}
          transform={`translateX(${SIGN_OUT_CLOSE_BUTTON_X_ALIGN_OFFSET})`}
          zIndex={1}
          boxSize={SIGN_OUT_CLOSE_BUTTON_SIZE}
          minW={SIGN_OUT_CLOSE_BUTTON_SIZE}
          p={0}
          bg="transparent"
          color={styles.subtleText}
          borderWidth="0"
          borderRadius="0"
          variant="ghost"
          onClick={onClose}
          _hover={{bg: 'transparent', color: styles.textColor}}
          _active={{bg: 'transparent'}}
          _focus={{bg: 'transparent'}}
          _focusVisible={styles.focusOutlineStyles}
        />
        <ModalBody p={0}>
          <Box
            bg={styles.surfaceBg}
            borderWidth="1px"
            borderColor={styles.borderColor}
            borderRadius="xl"
            boxShadow={styles.cardShadow}
            overflow="hidden"
          >
            <VStack spacing={4} align="stretch" p={SIGN_OUT_CARD_PADDING}>
              <Text
                as="h2"
                color={styles.textColor}
                fontSize="2xl"
                fontWeight="semibold"
                lineHeight="1.25"
                letterSpacing="0"
                mb={0}
                pt={1}
                pb={2}
                pr={10}
                noOfLines={2}
                wordBreak="break-word"
              >
                Ready to sign out?
              </Text>

              <Text color={styles.subtleText} lineHeight="1.6">
                For patient privacy, please sign out when you are finished with
                this workstation. You can sign back in anytime to continue your
                clinical work.
              </Text>

              <HStack justify="flex-end" spacing={3} pt={2}>
                <Button
                  type="button"
                  variant="outline"
                  maxW="200px"
                  onClick={onClose}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  colorScheme="red"
                  maxW="200px"
                  onClick={handleConfirm}
                >
                  Sign Out
                </Button>
              </HStack>
            </VStack>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SignOutConfirmModal;
